<template>
  <div>
    <mtd-header height="48px">
      <div class="title">数据安全运营平台</div>
      <div class="user-name" style="margin-right: 10px;">
        <mtd-dropdown trigger="hover">
          <mtd-button type="text" style="padding:0;width:22px; min-width: 22px;">
            <img class="user-name-img" :src="login_user.avatar">
          </mtd-button>
          <mtd-dropdown-menu slot="dropdown" class="platform-user-dropdown">
            <mtd-dropdown-menu-item>
              <div class="platform-user-info">
                <img class="platform-user-img" :src="login_user.avatar">
                <span class="platform-user-name">{{login_user.username}}</span>
                <span class="platform-user-name">{{login_user.mis_id}}</span>
              </div>
            </mtd-dropdown-menu-item>
            <mtd-dropdown-menu-item>
              <div style="padding: 4px 12px; color: rgba(0, 0, 0, 0.84);">
                <mtd-button type="text" icon="mtdicon mtdicon-log-out" @click="logout">退出</mtd-button>
              </div>
            </mtd-dropdown-menu-item>
          </mtd-dropdown-menu>
        </mtd-dropdown>
      </div>
    </mtd-header>
    <div style="padding: 24px">
      <mtd-row class="height-64 line-height-64">
        <mtd-col :span="24" class="height-full">
          <mtd-icon-button class="demo-icon-btn" type="secondary" icon="mtdicon mtdicon-arrow-left" @click="back_alarms"/>
          <span class="page-head-title" style="margin-left: 12px;">告警通知</span>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2 && alarm_info.beAlertedMis === alarm_info.recipient">需本人反馈</mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-else-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2 && alarm_info.supervisor === alarm_info.recipient">需直属主管反馈</mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-else-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 2">需抄送人反馈</mtd-tag>
          <mtd-tag theme="red" type="pure" class="page-head-title-tag" v-if="alarm_info.taskStatus !== 100 && alarm_info.rowStatus === 3">需直属主管 {{ alarm_info.supervisor }} 确认</mtd-tag>
          <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.taskStatus !== 100 && (alarm_info.rowStatus === 4 || alarm_info.rowStatus === 5)">已处理</mtd-tag>
          <mtd-tag theme="green" type="pure" class="page-head-title-tag" v-if="alarm_info.taskStatus === 100">完成</mtd-tag>
          <mtd-button v-if="appeal_edit_show && alarm_info.rowStatus === 3" class="btn-demo-item" ghost type="primary"
                      style="float: right; margin-top: 13px"
                      v-clipboard:copy="urge_url"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onError">复制催办链接</mtd-button>
        </mtd-col>
      </mtd-row>
      <mtd-row>
        <mtd-col :span="24" class="height-full padding-left-40">
          <mtd-announcement
            title="公告信息"
            type="info"
            show-icon>
            <span>
              请关注告警内容，我们将持续保障您的数据安全。
              如有疑问请大象联系<a href="https://x.sankuai.com/bridge/chat?pubid=137444543861" target="_blank">数据安全小助手</a>或<a href="https://tt.sankuai.com/ticket/create?cid=35&tid=984&iid=7539" target="_blank">提交TT工单</a>。
            </span>
          </mtd-announcement>
        </mtd-col>
      </mtd-row>
      <mtd-row class="height-56 line-height-56">
        <mtd-col :span="24" class="height-full padding-left-40">
          <span class="page-second-title" v-if="risk_summary.length === 0">提醒信息</span>
        </mtd-col>
      </mtd-row>
      <mtd-row>
        <mtd-col :span="24" class="height-full padding-left-40" v-if="login_user.mis_id === alarm_info.beAlertedMis">
          <span>你好，识别到【{{ alarm_info.beAlertedMis }}】近期行为有违规嫌疑，请确认信息后进行反馈。</span>
        </mtd-col>
        <mtd-col :span="24" class="height-full padding-left-40" v-else-if="login_user.mis_id === alarm_info.supervisor">
          <span>您好，识别到</span>
          <span style="color: #F5483B;">您的下属{{alarm_info.beAlertedMis}}</span>
          <span>近期行为存在一定风险，请您查看以下信息并进行反馈确认。</span>
        </mtd-col>
        <mtd-col :span="24" class="height-full padding-left-40" v-else-if="login_user.mis_id !== alarm_info.beAlertedMis && login_user.mis_id !== alarm_info.supervisor">
          <span>您好，识别到【{{alarm_info.beAlertedMis}}】近期行为存在一定风险，请您查看以下信息并进行反馈确认。</span>
        </mtd-col>
      </mtd-row>
      <div>
        <mtd-row>
          <mtd-col :span="24" class="height-full padding-left-40">
            <table class="full-block-table" style="margin-top: 16px;">
              <tr class="table-row">
                <td class="td-title">{{alarm_info.targetType === 2 ? "责任人" : "当事人账号" }}</td>
                <td>{{alarm_info.beAlertedMis}}</td>
              </tr>
              <tr class="table-row">
                <td class="td-title">风险等级</td>
                <td>
                  <mtd-tag theme="red" type="pure" size="small" v-if="alarm_info.riskLevel === 'P0'">紧急</mtd-tag>
                  <mtd-tag theme="orange" type="pure" size="small" v-if="alarm_info.riskLevel === 'P1'">高</mtd-tag>
                  <mtd-tag theme="purple" style="background-color: #EFC46F;border-color: #EFC46F" type="pure" size="small" v-if="alarm_info.riskLevel === 'P2'">中</mtd-tag>
                  <mtd-tag theme="blue" type="pure" size="small" v-if="alarm_info.riskLevel === 'P3'">低</mtd-tag>
                </td>
              </tr>
              <tr class="table-row">
                <td class="td-title">风险详情</td>
                <td class="alarm_info_content" v-if="alarm_info.beAlertedMis === this.login_user.mis_id"><span v-html="alarm_info.content"></span></td>
                <td class="alarm_info_content" v-else-if="alarm_info.supervisor === this.login_user.mis_id"><span v-html="alarm_info.superiorContent ? alarm_info.superiorContent : alarm_info.content"></span></td>
                <td class="alarm_info_content" v-else-if="is_cc_role"><span v-html="alarm_info.ccContent ? alarm_info.ccContent : alarm_info.content"></span></td>
                <td class="alarm_info_content" v-else><span v-html="alarm_info.supervisor === this.login_user.mis_id ? alarm_info.superiorContent : alarm_info.content"></span></td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
        <mtd-row v-if="alarm_info.rowStatus === 1" style="margin-top: 9px;">
          <mtd-col :span="24" class="height-full padding-left-40">
            <span>如对此告警有异议，可以点击</span>
            <span style="color:  #0A70F5;cursor: pointer" @click="appeal_show = true">我要反馈</span>
          </mtd-col>
        </mtd-row>
        <!-- 用户反馈表单 -->
        <mtd-row v-if="appeal_show && !appeal_result_show && !file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full padding-left-40">
            <div class="feedback-reason-block">
              <div>
                <span class="page-second-title">反馈</span>
              </div>
              <div style="margin-top: 5px;">
                <mtd-form :label-width="46">
                  <div v-if="alarm_info.noticeConfig">
                    <mtd-form-item label="原因:" class="small-mtd-form-item">
                      <mtd-radio-group v-model="appeal_type">
                        <mtd-radio :value="item" v-for="(item, index) in radioList" :key="index">{{ item }}</mtd-radio>
                      </mtd-radio-group>
                    </mtd-form-item>
                  </div>
                  <div v-else>
                    <mtd-form-item label="原因:" class="small-mtd-form-item">
                      <mtd-radio-group v-model="appeal_type">
                        <mtd-radio :value="item" v-for="(item, index) in radioList" v-bind:key="index">{{ item }}</mtd-radio>
                      </mtd-radio-group>
                    </mtd-form-item>
                  </div>
                  <mtd-form-item label="" class="small-mtd-form-item">
                    <mtd-textarea placeholder="请输入反馈信息" v-model="appeal_other_reason" style="width: 100%;"
                                  rows="3" maxlength="500" :invalid="appeal_other_reason === ''" />
                  </mtd-form-item>
                  <mtd-form-item style="margin-top: 12px">
                    <mtd-button type="primary" style="margin-right: 12px;" @click="submit_appeal_reason" :disabled="appeal_type === '' || appeal_other_reason === ''">
                      确定
                    </mtd-button>
                    <mtd-button @click="appeal_show = false" v-if="alarm_info.rowStatus === 1">取消</mtd-button>
                    <mtd-button @click="editCancel" v-if="alarm_info.rowType === 2 && editAppealFlag">取消</mtd-button>
                  </mtd-form-item>
                </mtd-form>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 外发质询用户反馈表单 -->
        <mtd-row v-if="appeal_show && !appeal_result_show && file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full padding-left-40">
            <div class="feedback-reason-block">
              <div>
                <span class="page-second-title">反馈</span>
              </div>
              <div style="margin-top: 5px;">
                <mtd-form :label-width="120">
                  <div v-if="alarm_info.noticeConfig">
                    <mtd-form-item label="原因:" class="small-mtd-form-item">
                      <mtd-radio-group v-model="appeal_type">
                        <mtd-radio :value="item" v-for="(item, index) in radioList" :key="index">{{ item }}</mtd-radio>
                      </mtd-radio-group>
                    </mtd-form-item>
                  </div>
                  <div v-else>
                    <mtd-form-item label="原因:" class="small-mtd-form-item">
                      <mtd-radio-group v-model="appeal_type">
                        <mtd-radio :value="item" v-for="(item, index) in radioList" v-bind:key="index">{{ item }}</mtd-radio>
                      </mtd-radio-group>
                    </mtd-form-item>
                  </div>
                  <mtd-form-item label="发给了谁:"  class="small-mtd-form-item mtd-form-item-required">
                    <mtd-input v-model="sendObject" style="width: 100%" placeholder="如：同事mis、合作伙伴公司和名称等，没有可以填无"/>
                  </mtd-form-item>
                  <mtd-form-item label="发送记录证明:" class="small-mtd-form-item" helper="说明：包含文件、发送时间和接收者账号的相关截图">
                    <div>
                      <mtd-upload
                        class="picture-list"
                        action="/api/task/uploadImg"
                        list-type="picture-card"
                        accept="image/*"
                        :on-success="uploadToVenus"
                        :before-remove="removePicture"
                        :on-preview="handlePictureCardPreview"
                        :file-list="files">
                        <i class="mtdicon-add" />
                      </mtd-upload>
                      <mtd-modal v-model="previewVisible">
                        <img :src="previewImageUrl"/>
                      </mtd-modal>
                    </div>
                  </mtd-form-item>
                  <mtd-form-item label="说明:" class="small-mtd-form-item" required>
                    <mtd-textarea placeholder="填写文件内容或外发原因" v-model="appeal_other_reason" style="width: 100%;"
                                  rows="3" maxlength="500" />
                  </mtd-form-item>
                  <mtd-form-item style="margin-top: 12px">
                    <mtd-button type="primary" style="margin-right: 12px;" @click="submit_file_out" :disabled="file_out_disabled">
                      确定
                    </mtd-button>
                    <mtd-button @click="appeal_show = false" v-if="alarm_info.rowStatus === 1">取消</mtd-button>
                    <mtd-button @click="editCancel" v-if="alarm_info.rowType === 2 && editAppealFlag">取消</mtd-button>
                  </mtd-form-item>
                </mtd-form>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 用户反馈结果展示 -->
        <mtd-row v-if="appeal_result_show && !file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full padding-left-40">
            <span class="page-second-title">{{appeal_user}}的反馈信息</span>
            <mtd-icon-button v-if="appeal_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o" @click="editAppeal" />
          </mtd-col>
          <mtd-col :span="24" class="height-full padding-left-40">
            <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
              <tr class="table-row">
                <td class="td-title">原因</td>
                <td>{{alarm_info.appealType | appealTypeFilter(this.radioList)}}: {{alarm_info.appealReason}}</td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
        <mtd-row v-if="appeal_result_show && file_out_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full padding-left-40">
            <span class="page-second-title">{{appeal_user}}的反馈信息</span>
            <mtd-icon-button v-if="appeal_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o" @click="editAppeal" />
          </mtd-col>
          <mtd-col :span="24" class="height-full padding-left-40">
            <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
              <tr class="table-row">
                <td class="td-title">原因</td>
                <td>{{alarm_info.appealType | appealTypeFilter(this.radioList)}}{{alarm_info.appealReason}}</td>
              </tr>
              <tr class="table-row">
                <td class="td-title">发送对象</td>
                <td>{{ alarm_info.sendObject }}</td>
              </tr>
              <tr class="table-row">
                <td class="td-title">发送记录证明</td>
                <td>
                  <div style="margin-top: 16px">
                    <img :src="item" v-for="(item, index) in (alarm_info.pictures == null ? [] : alarm_info.pictures.split(','))"
                         v-bind:key="index" style="width: 160px;height: 160px;cursor: pointer" @click="picturePreview(item)"/>
                  </div>
                  <mtd-modal v-model="resultPreviewModal">
                    <img :src="activeImg"/>
                  </mtd-modal>
                </td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
        <!-- 领导确认表单 -->
        <mtd-row v-if="feedback_show && !feedback_result_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full padding-left-40">
            <div class="feedback-reason-block">
              <div>
                <span class="page-second-title">确认</span>
                <span class="submit-helper">请根据实际情况核实，如有隐瞒将根据阳光职场追究不诚信责任</span>
              </div>
              <div style="margin-top: 5px;">
                <mtd-form :label-width="46">
                  <mtd-form-item label="确认:" class="small-mtd-form-item">
                    <mtd-radio-group v-model="feedback_reason">
                      <mtd-radio :value="item" v-for="(item, index) in superiorRadioList" :key="index">{{ item }}</mtd-radio>
                    </mtd-radio-group>
                  </mtd-form-item>
                  <mtd-form-item label="" class="small-mtd-form-item">
                    <mtd-textarea placeholder="说明" v-model="feedback_other_reason" style="width: 100%;"
                                  rows="3" maxlength="500" />
                  </mtd-form-item>
                  <mtd-form-item>
                    <mtd-button type="primary" style="margin-right: 12px;" @click="submit_feedback_reason" :disabled="feedback_other_reason === '' || feedback_reason === ''">
                      确定
                    </mtd-button>
                    <mtd-button @click="editFeedbackCancel" v-if="editFeedbackFlag">取消</mtd-button>
                  </mtd-form-item>
                </mtd-form>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <!-- 领导确认结果 -->
        <mtd-row v-if="feedback_result_show" style="margin-top: 34px;">
          <mtd-col :span="24" class="height-full padding-left-40">
            <span class="page-second-title">{{alarm_info.supervisor}}的确认</span>
            <mtd-icon-button v-if="feedback_edit_show" class="demo-icon-btn" icon="mtdicon mtdicon-edit-o" @click="editFeedback" />
          </mtd-col>
          <mtd-col :span="24" class="height-full padding-left-40">
            <table class="full-block-table" style="margin-top: 16px;margin-bottom: 9px;">
              <tr class="table-row">
                <td class="td-title">确认</td>
                <td>{{alarm_info.feedbackReason}}</td>
              </tr>
            </table>
          </mtd-col>
        </mtd-row>
      </div>
      <div v-if="risk_summary.length !== 0">
        <mtd-row class="height-56 line-height-56">
          <mtd-col :span="24" class="height-full padding-left-40">
            <span class="page-second-title">风险详情</span>
            <mtd-button style="float: right;margin-top: 10px" class="btn-demo-item" type="primary" icon="mtdicon mtdicon-export-o" @click="export_to_excel()">导出为Excel</mtd-button>
          </mtd-col>
        </mtd-row>
        <mtd-row>
          <mtd-col class="height-full padding-left-40">
            <mtd-table :data="risk_summary" size="small" :height="risk_height" bordered>
              <mtd-table-column v-for="(item,key) in risk_summary_mapping" :key="key" :prop="key" :label="item" resizable/>
            </mtd-table>
          </mtd-col>
        </mtd-row>
        <mtd-row class="height-56 line-height-56">
          <mtd-col :span="24" class="height-full padding-left-40">
            <span class="page-second-title">明细日志</span>
          </mtd-col>
        </mtd-row>
        <mtd-row>
          <mtd-col class="height-full padding-left-40">
            <mtd-table :data="risk_details_show" size="small" bordered>
              <mtd-table-column v-for="(item,key) in risk_details_mapping" :key="key" :prop="key" :label="item" resizable show-overflow-tooltip />
            </mtd-table>
            <mtd-pagination
              show-size-changer
              :total="risk_details.length"
              :show-total="true"
              :current-page.sync="currentPage"
              :page-size.sync="limit"
              size="small"
              @change="change_risk_details"
              style="float: right;margin-top: 13px" />
          </mtd-col>
        </mtd-row>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'
  import sso from '@/utils/sso'

  export default {
    name: "detail",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
      appealTypeFilter(appealType, array) {
        if (!appealType || appealType === '0') {
          return '暂未反馈';
        } else {
          return array.find(item => item === appealType) + '：';
        }
      }
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      file_out_disabled() {
        return this.appeal_type === '' || this.appeal_other_reason === '' || this.sendObject === '';
      }
    },
    data() {
      return {
        alarm_id: this.$route.params.id,
        alarm_info: {},
        // 用户反馈
        appeal_show: false,
        appeal_type: '',
        appeal_other_reason: '',
        // 外发质询用户反馈表单
        file_out_show: false,
        sendObject: '',
        files: [],
        pictureUrl: [],
        previewVisible: false,
        previewImageUrl: '',
        // 用户反馈展示
        appeal_user: '',
        appeal_result_show: false,
        appeal_edit_show: false,
        // 领导确认
        feedback_show: false,
        feedback_reason: '',
        feedback_other_reason: '',
        // 领导确认展示
        feedback_result_show: false,
        feedback_edit_show: false,
        // 风险概览表格映射和数据
        risk_summary_mapping:{},
        risk_summary:[],
        // 风险详情表格映射和数据
        risk_details_mapping:{},
        risk_details:[],
        risk_details_show:[],
        currentPage: 1,
        limit: 10,
        risk_height: '',
        editAppealFlag: false,
        editFeedbackFlag: false,
        selection:[],
        detailReason: '',
        activeImg: '',
        resultPreviewModal: false,
        radioList: ['工作需要', '不是本人操作', '不清楚原因', '其他'],
        superiorRadioList: ['情况属实', '存在异常', '其他'],
        // 催办链接
        urge_url: window.location.href,
        is_cc_role: false,
      }
    },
    mounted: function () {
      this.init_data();
    },
    methods: {
      ...mapActions([
        'api_query_reminders_inquiries_by_id',
        'api_update_reminders_inquiries',
      ]),
      logout() {
        sso.logout();
      },
      checkboxable (row) {
        if (row.governStatus !== 0) {
          return false;
        } else {
          return true;
        }
      },
      change_risk_details(current, size) {
        this.currentPage = current;
        this.limit = size;
        let temp = this.risk_details;
        let start = (this.currentPage - 1) * this.limit;
        let end = this.currentPage * this.limit;
        this.risk_details_show = temp.slice(start,end);
      },
      async init_data() {
        let response = await this.api_query_reminders_inquiries_by_id({id: this.alarm_id});
        this.alarm_info = response.data;
        if (this.alarm_info.cc) {
          this.is_cc_role = this.alarm_info.cc.indexOf(this.login_user.mis_id) !== -1;
        }
        if (this.alarm_info.automaticDispositionId === 14) {
          this.file_out_show = true;
        }
        if (this.alarm_info.needPicture) {
          this.file_out_show = true;
        }
        // 如果是接收人
        if (this.alarm_info.rowStatus === 2 && this.alarm_info.recipient.indexOf(this.login_user.mis_id) !== -1) {
          this.appeal_show = true;
        }
        // 如果是接收人，展示编辑反馈按钮
        if (this.alarm_info.recipient.indexOf(this.login_user.mis_id) !== -1) {
          this.appeal_edit_show = true;
        }
        // 是领导，展示编辑反馈按钮
        if (this.alarm_info.supervisor === this.login_user.mis_id) {
          this.feedback_edit_show = true;
        }
        // 是领导，但用户尚未反馈
        if (this.alarm_info.supervisor !== this.alarm_info.recipient
          && this.alarm_info.supervisor === this.login_user.mis_id && this.alarm_info.rowStatus === 2) {
          this.appeal_result_show = true;
        }
        // 如果是领导，展示领导反馈
        if (this.alarm_info.supervisor === this.login_user.mis_id && this.alarm_info.supervisorFlag === 1 && this.alarm_info.rowStatus === 3) {
          this.feedback_show = true;
        }
        // 如果反馈不为空，展示已反馈内容
        if (this.alarm_info.appealReason != null && this.alarm_info.appealReason !== '') {
          this.appeal_result_show = true;
          this.appeal_user = this.alarm_info.appealUser;
        } else {
          this.appeal_user = this.alarm_info.recipient;
        }
        // 如果领导反馈不为空，展示领导反馈内容
        if (this.alarm_info.recipient.indexOf(this.login_user.mis_id) === -1 && this.alarm_info.feedbackReason != null && this.alarm_info.feedbackReason !== '') {
          this.feedback_result_show = true;
        }
        if (this.alarm_info.noticeConfig) {
          if (this.alarm_info.noticeConfig.feedbackLabelList) {
            this.radioList = this.alarm_info.noticeConfig.feedbackLabelList.split(',');
          }
          if (this.alarm_info.noticeConfig.supervisorFeedbackLabelList) {
            this.superiorRadioList = this.alarm_info.noticeConfig.supervisorFeedbackLabelList.split(',');
          }
        }
      },
      handlePictureCardPreview (file) {
        this.previewImageUrl = file.url;
        this.previewVisible = true;
      },
      uploadToVenus(response, file) {
        if (response.code === 0) {
          file.url = response.data;
          this.files.push(file);
        } else {
          this.$mtd.message.error("上传失败");
        }
      },
      picturePreview(item) {
        this.activeImg = item;
        this.resultPreviewModal = true;
      },
      removePicture(file) {
        this.files.splice(this.files.indexOf(file), 1);
      },
      submit_file_out() {
        let vm = this;
        let pictureUrl = [], formData = {};
        for (let i = 0; i < this.files.length; i++) {
          pictureUrl.push(this.files[i].url);
        }
        formData.appealType = this.appeal_type;
        formData.appealReason = this.appeal_other_reason;
        formData.pictures = pictureUrl.join(",");
        formData.sendObject = this.sendObject;
        formData.id = this.alarm_id;
        this.api_update_reminders_inquiries(formData).then(function () {
          vm.init_data();
        });
      },
      back_alarms() {
        this.$router.push('/logout_index');
      },
      submit_appeal_reason() {
        let vm = this;
        if (this.appeal_reason === 0) {
          vm.$mtd.message.error('请选择原因');
          return;
        }
        if (this.appeal_other_reason === '') {
          vm.$mtd.message.error('请填写反馈详情');
          return;
        }

        let params = {id: this.alarm_id, appealUser: this.login_user.mis_id};
        params['appealType'] = this.appeal_type;
        params['appealReason'] = this.appeal_other_reason;
        this.api_update_reminders_inquiries(params).then(function () {
          vm.init_data();
        });
      },
      submit_feedback_reason() {
        let vm = this;
        if (this.feedback_reason === '') {
          vm.$mtd.message.error('请确认信息');
          return;
        }
        if (this.feedback_other_reason === '') {
          vm.$mtd.message.error('请填写确认信息');
          return;
        }

        let params = {id: this.alarm_id};
        params['feedbackReason'] = this.feedback_reason + '：' + this.feedback_other_reason;
        this.api_update_reminders_inquiries(params).then(function () {
          vm.init_data();
        });
      },
      editAppeal() {
        this.appeal_result_show = false;
        this.editAppealFlag = true;
        this.appeal_show = true;
        // 图片同步
        if (this.alarm_info.pictures != null) {
          let strings = this.alarm_info.pictures.split(',');
          this.files = [];
          strings.forEach(picture => {
            this.files.push({url: picture});
          });
        }

        this.sendObject = this.alarm_info.sendObject;
        this.appeal_type = this.alarm_info.appealType;
        this.appeal_other_reason = this.alarm_info.appealReason;
      },
      editCancel() {
        this.appeal_show = false;
        this.appeal_result_show = true;
      },
      editFeedback() {
        this.feedback_result_show = false;
        this.editFeedbackFlag = true;
        this.feedback_show = true;
        let array = this.alarm_info.feedbackReason.split("：");

        this.feedback_reason = array[0];
        this.feedback_other_reason = array[1];
      },
      editFeedbackCancel() {
        this.feedback_show = false;
        this.feedback_result_show = true;
      },
      onCopy() {
        this.$mtd.message.success("复制成功");
      },
      onError() {
        this.$mtd.message.error("复制失败");
      },
    },
  }
</script>

<style>
   @import "../../../styles/main-container.css";
   @import "../../../styles/public.css";

  .page-head-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 20px;
    color: #333333;
    letter-spacing: 0.5px;
    line-height: 28px;
  }

  .page-head-title-tag {
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 6px;
    margin-left: 8px;
  }

  .page-second-title {
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.87);
    letter-spacing: 0;
    line-height: 22px;
  }

  .padding-left-40 {
    padding-left: 40px;
  }

  .full-block-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    border: 1px solid rgba(0, 0, 0, 0.06);
  }

  .full-block-table .table-row {
    height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  .none-height-table>.table-row {
    height: auto !important;
  }

  .full-block-table .table-row td {
    line-height: 36px;
    font-family: PingFangSC-Medium, sans-serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.60);
    letter-spacing: 0;
    padding: 0 12px;
    border-right: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    /*white-space: nowrap;*/
    /*text-overflow: ellipsis;*/
  }

  .full-block-table .table-row td.td-title {
    background: #F7F7F7;
    width: 130px;
  }

  .feedback-reason-block {
    background: #F7F7F7;
    border: 1px solid rgba(0, 0, 0, 0.07);
    padding: 15px;
    padding-bottom: 0;
  }
  .full-block-table .table-row td.alarm_info_content{
    white-space: normal;
    line-height: 20px;
  }
  .submit-helper {
    font-size: 12px;
    line-height: 20px;
    color: rgba(0,0,0,.36);
    margin-left: 4px;
  }
   .platform-user-dropdown .mtd-dropdown-menu-item {
     padding: 0;
   }

   .platform-user-dropdown .platform-user-info {
     padding: 8px 12px;
     border-bottom: 1px solid #f7f7f7;
     position: relative;
   }

   .platform-user-dropdown .platform-user-info .platform-user-img {
     height: 28px;
     width: 28px;
     border-radius: 50%;
     vertical-align: middle;
     position: absolute;
     top: 17px;
   }

   .platform-user-dropdown .platform-user-info .platform-user-name {
     margin-left: 36px;
     font-size: 14px;
     color: rgba(0, 0, 0, 0.87);
     display: block;
     line-height: 22px;
   }

   .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item {
     height: 36px;
     line-height: 36px;
     padding: 0 12px;
     cursor: pointer;
   }

   .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item .platform-user-dropdown-link {
     display: block;
     overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     color: rgba(0, 0, 0, 0.87);
     font-size: 14px;
   }

   .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) {
     height: 48px;
     line-height: 48px;
   }

   .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) i {
     margin-right: 4px;
     font-size: 20px;
     color: rgba(0, 0, 0, 0.87);
     vertical-align: middle;
   }

   .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:hover {
     background-color: #f7f7f7;
   }
</style>
